import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";
import MobileHelper from "../../../../../helpers/mobile";

export default function AllMarketerUserEditLog() {
  const params = useParams();
  const userID = params.userID;
  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getMarketerLogs();
  }, [currentPage, countItemPerPage]);

  const getMarketerLogs = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultRequestGetLogs = await sendRequestGetLogs(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultRequestGetLogs) {
      return;
    }

    setLogs(resultRequestGetLogs.logs_edit.reverse());
    setCountPage(resultRequestGetLogs.count_page);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const sendRequestGetLogs = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let logs;
    try {
      logs = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/log-edit/user-id/${userID}?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return logs.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateLogs = () => {
    if (logs.length == 0) {
      return <></>;
    }

    return logs.map((log, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumber.toPersianNum(index + 1)}</td>
          <td>{helpersNumber.toPersianNum(log.log_id)}</td>
          <td>{helpersNumber.toPersianNum(log.log_first_percent_before)}</td>
          <td>{helpersNumber.toPersianNum(log.log_first_percent_after)}</td>
          <td>
            {helpersNumber.toPersianNum(log.log_type_collaboration_before)}
          </td>
          <td>
            {helpersNumber.toPersianNum(log.log_type_collaboration_after)}
          </td>
          <td>
            {helpersNumber.toPersianNum(
              helpersTime.convertGregorianToJalali(log.log_created_at) +
                " " +
                log.log_created_at.split(" ")[1]
            )}
          </td>
          <td>
            <Link
              to={`/user/marketer/edit/log/${log.log_id}`}
              className="btn btn-info"
            >
              <i className="fa fa-info"></i>
            </Link>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">همه کاربران بازاریاب</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/user/marketer/all" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              <div className="table-responsive pt-2">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره لاگ</td>
                      <td>درصد اولیه قبل</td>
                      <td>درصد اولیه بعد</td>
                      <td>نوع همکاری قبل</td>
                      <td>نوع همکاری بعد</td>
                      <td>تاریخ بروزرسانی</td>
                      <td>نمایش</td>
                    </tr>
                  </thead>
                  <tbody>{generateLogs()}</tbody>
                </table>
              </div>
              {countPage > 1 ? generatePagination() : <></>}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
